import { Attribute, getIdFromAttributes, getNameFromAttributes } from 'domain/experiment/attribute';

// note: this signature is not supported: getEntityDisplayName(nameOrShortId: string | undefined);
export function getEntityDisplayName(name: string | undefined, shortId: string): string;
export function getEntityDisplayName(attributes: Attribute[], shortId: string): string;
export function getEntityDisplayName(
  entityAlike: { attributes: Attribute[] },
  shortId: string,
): string;
export function getEntityDisplayName(name: string | undefined, attributes: Attribute[]): string;
export function getEntityDisplayName(attributes: Attribute[]): string;
export function getEntityDisplayName(
  entityAlike: { attributes: Attribute[] },
  attributes: Attribute[],
): string;
export function getEntityDisplayName(
  name: string | undefined,
  entityAlike: { attributes: Attribute[] },
): string;
export function getEntityDisplayName(
  attributes: Attribute[],
  entityAlike: { attributes: Attribute[] },
): string;
export function getEntityDisplayName(entityAlike: { attributes: Attribute[] }): string;

export function getEntityDisplayName(
  nameOrAttributesOrEntityAlike: string | Attribute[] | { attributes: Attribute[] } | undefined,
  shortIdOrAttributesOrEntityAlike?: string | Attribute[] | { attributes: Attribute[] },
): string {
  let shortId = '';
  let name: string | undefined = undefined;

  if (
    (typeof nameOrAttributesOrEntityAlike === 'string' ||
      nameOrAttributesOrEntityAlike === undefined) &&
    shortIdOrAttributesOrEntityAlike === undefined
  ) {
    throw new Error('Not supported.');
  }

  if (typeof nameOrAttributesOrEntityAlike === 'string') {
    name = nameOrAttributesOrEntityAlike;
  } else if (Array.isArray(nameOrAttributesOrEntityAlike)) {
    name = getNameFromAttributes(nameOrAttributesOrEntityAlike);
  } else if (
    typeof nameOrAttributesOrEntityAlike === 'object' &&
    'attributes' in nameOrAttributesOrEntityAlike
  ) {
    name = getNameFromAttributes(nameOrAttributesOrEntityAlike.attributes);
  }

  if (shortIdOrAttributesOrEntityAlike === undefined) {
    // handling a single argument case (nameOrAttributesOrEntityAlike is not a string here, so shortId is not polluted with name)
    shortIdOrAttributesOrEntityAlike = nameOrAttributesOrEntityAlike;
  }

  if (typeof shortIdOrAttributesOrEntityAlike === 'string') {
    shortId = shortIdOrAttributesOrEntityAlike;
  } else if (Array.isArray(shortIdOrAttributesOrEntityAlike)) {
    shortId = getIdFromAttributes(shortIdOrAttributesOrEntityAlike) ?? '';
  } else if (typeof shortIdOrAttributesOrEntityAlike === 'object') {
    shortId = getIdFromAttributes(shortIdOrAttributesOrEntityAlike.attributes) ?? '';
  }

  return name?.trim() || `[${shortId}]`;
}
